import React from 'react';
import { Button } from '../../../ui-components/ui/button';
import { 
  Phone, 
  Calendar, 
  CheckSquare, 
  Mail, 
  MessageSquare
} from 'lucide-react';
import { toast } from 'sonner';

interface QuickActivityButtonsProps {
  dealId: string;
  onActivityCreate: (type: string) => void;
  disabled?: boolean;
}

export const QuickActivityButtons: React.FC<QuickActivityButtonsProps> = ({
  dealId,
  onActivityCreate,
  disabled = false
}) => {
  const activities = [
    { 
      type: 'call', 
      icon: Phone, 
      label: 'Anruf',
      color: 'text-green-600 hover:text-green-700',
      bgColor: 'hover:bg-green-50'
    },
    { 
      type: 'meeting', 
      icon: Calendar, 
      label: 'Meeting',
      color: 'text-blue-600 hover:text-blue-700',
      bgColor: 'hover:bg-blue-50'
    },
    { 
      type: 'task', 
      icon: CheckSquare, 
      label: 'Aufgabe',
      color: 'text-purple-600 hover:text-purple-700',
      bgColor: 'hover:bg-purple-50'
    },
    { 
      type: 'email', 
      icon: Mail, 
      label: 'E-Mail',
      color: 'text-orange-600 hover:text-orange-700',
      bgColor: 'hover:bg-orange-50'
    },
    { 
      type: 'note', 
      icon: MessageSquare, 
      label: 'Notiz',
      color: 'text-gray-600 hover:text-gray-700',
      bgColor: 'hover:bg-gray-50'
    }
  ];

  const handleActivityClick = (type: string) => {
    if (type === 'meeting' || type === 'call' || type === 'task' || type === 'note') {
      onActivityCreate(type);
    } else if (type === 'email') {
      // Email functionality - for now just create activity
      onActivityCreate(type);
    }
  };

  return (
    <div className="flex items-center gap-1">
      {activities.map(({ type, icon: Icon, label, color, bgColor }) => (
        <Button
          key={type}
          variant="ghost"
          size="sm"
          disabled={disabled}
          onClick={() => handleActivityClick(type)}
          className={`${color} ${bgColor} px-2 py-1 h-8`}
          title={label}
        >
          <Icon className="h-4 w-4" />
          <span className="ml-1 text-xs hidden sm:inline">{label}</span>
        </Button>
      ))}
    </div>
  );
};

export default QuickActivityButtons;
